import type { ReactNode } from 'react'

/** Small text button for a section header's action slot. */
export function HeaderLink({ onClick, disabled, children }: { onClick: () => void; disabled?: boolean; children: ReactNode }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="text-xs font-medium text-primary hover:text-primary/80 transition-colors cursor-pointer disabled:pointer-events-none disabled:opacity-50"
    >
      {children}
    </button>
  )
}
